import { render } from "./KeyWordList.vue?vue&type=template&id=3d8c3ace&scoped=true"
import script from "./KeyWordList.vue?vue&type=script&lang=js"
export * from "./KeyWordList.vue?vue&type=script&lang=js"

import "./KeyWordList.vue?vue&type=style&index=0&id=3d8c3ace&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8c3ace"],['__file',"src/views/qywx/ai/quotation/KeyWordList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d8c3ace"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d8c3ace', __exports__)) {
    api.reload('3d8c3ace', __exports__)
  }
  
  module.hot.accept("./KeyWordList.vue?vue&type=template&id=3d8c3ace&scoped=true", () => {
    api.rerender('3d8c3ace', render)
  })

}


export default __exports__